module.exports = __webpack_public_path__ + "img/arrow-right-white.d20bbbae.svg";